import {Tooltip} from "antd";
import React from "react";

export default function VulnerabilitiesLabel() {
    return <Tooltip title="Each vulnerability is counted once across all components.">
        <span>Vulnerabilities</span>
    </Tooltip>;
}
